module.exports = __webpack_public_path__ + "img/202405_07.70292e81.jpg";